import { Injectable } from '@angular/core';
import { CloudRecentFilesService } from './cloud-storage/cloud-recent-files.service';
import { DropboxApiService } from './cloud-storage/dropbox/dropbox-api.service';
import { CloudServiceEnum } from './cloud-storage/enums';
import { GapiSession } from './cloud-storage/google-drive/gapi.session';
import { OneDriveAuthService } from './cloud-storage/one-drive/one-drive.auth.service';

@Injectable({
  providedIn: 'root'
})
export class CloudSettingsService {
  supporedtedClouds: Array<CloudServiceEnum> = [CloudServiceEnum.GoogleDrive, CloudServiceEnum.DropBox, CloudServiceEnum.OneDrive];

  constructor(
    private readonly gapi: GapiSession,
    private readonly dropbox: DropboxApiService,
    private readonly onedrive: OneDriveAuthService,
    private readonly cloudRecentFilesService: CloudRecentFilesService,
  ) { }

  getFirstConnectedCloud(): CloudServiceEnum{
    const connected = CloudServiceEnum.CloudStorage;
    for (let cloud of this.supporedtedClouds){
      if(this.isCloudConnected(cloud)){
        return cloud;
      }
    }
    return connected;
  }

  getSupportedClouds() {
    return this.supporedtedClouds;
  }

  isCloudConnected(cloud: CloudServiceEnum): boolean {
    switch (cloud) {
      case CloudServiceEnum.GoogleDrive:
        return this.gapi.isConnected();
      case CloudServiceEnum.OneDrive:
        return this.onedrive.isConnected();
      case CloudServiceEnum.DropBox:
        return this.dropbox.isConnected();
      default:
        return false;
    }
  }

  async connectCloud(cloud: CloudServiceEnum) {
    switch (cloud) {
      case CloudServiceEnum.GoogleDrive:
        return await this.gapi.getUserToken();
      case CloudServiceEnum.DropBox:
        return await this.dropbox.getToken();
      case CloudServiceEnum.OneDrive:
        return await this.onedrive.authorizeOneDrive();
    }
  }

  async dicsonnectCloud(cloud: CloudServiceEnum) {
    this.cloudRecentFilesService.clearCloudRecentFiles(cloud);

    switch (cloud) {
      case CloudServiceEnum.GoogleDrive:
        await this.gapi.unAttachDrive();
        break;
      case CloudServiceEnum.DropBox:
        await this.dropbox.unAttachDrive();
        break;
      case CloudServiceEnum.OneDrive:
        await this.onedrive.unAttachDrive();
        break;
    }
  }
}
